export { default } from "./DarkThemeModal";
